export const generateUrlQuery = params => {
  if (!params) {
    return '';
  }
  let query = '?';
  Object.keys(params).forEach(key => {
    if (params[key]) {
      if (Array.isArray(params[key])) {
        const values = params[key];
        values.forEach(val => {
          query += `${key}[]=${val}&`;
        });
      } else {
        query += `${key}=${params[key]}&`;
      }
    }
  });

  return query;
};
